// Phase 6.F-1 — 빌드 타임에 vite define 으로 주입된 git rev.
// dist/index-*.js 에 string literal 로 박혀 verify:deployed 가 grep 으로 검출.
export const GIT_REV: string = __GIT_REV__;
